import React from 'react';
import { ReferralButton } from './ReferralButton';
import { Reveal } from './Reveal';
const pillars = [{
  label: 'Explora',
  text: 'Conoce los mercados y productos disponibles.'
}, {
  label: 'Analiza',
  text: 'Usa la información y las herramientas de la plataforma.'
}, {
  label: 'Decide',
  text: 'Toma tus propias decisiones, con tus propios criterios.'
}];
export function MomentumSection() {
  return <section className="relative overflow-hidden bg-base px-5 py-28 lg:px-8 lg:py-36" data-id="element-188" data-mp="1evnwz625547y">
      <AscendingBackdrop data-id="element-189" data-mp="1jv0i9mdd638f" />

      <div className="mx-auto max-w-shell text-center" data-id="element-190" data-mp="1ju7jp8ok6k1d">
        <Reveal data-id="element-191" data-mp="1oms7ntksa2wz">
          <h2 className="mx-auto max-w-[760px] text-[34px] font-extrabold uppercase leading-[0.98] tracking-tightest text-white sm:text-[52px]" data-id="element-192" data-mp="1om8s2jilvqm4">
            El mercado crypto no se detiene.
          </h2>
          <p className="mx-auto mt-6 max-w-[460px] text-[15px] leading-relaxed text-ink-muted" data-id="element-193" data-mp="1ylpwyyq1a0h1">
            Prepárate, explora el mercado y toma tus propias decisiones.
          </p>
        </Reveal>

        <ul className="mx-auto mt-14 grid max-w-[880px] gap-px overflow-hidden rounded-3xl border border-hairline bg-hairline sm:grid-cols-3" data-id="element-194" data-mp="2j2uwuem2a5ah">
          {pillars.map((pillar, i) => <Reveal as="li" key={pillar.label} delay={i * 0.06} data-id="element-195" data-mp="292ubkn4mtf3n" data-mpi={i}>
              <div className="flex h-full flex-col items-center bg-base/90 px-6 py-8" data-id="element-196" data-mp="295grba1of0wy">
                <span className="text-[15px] font-extrabold uppercase tracking-[0.22em] text-brand" data-id="element-197" data-mp="246ni3ttf9w2l">
                  {pillar.label}
                </span>
                <p className="mt-3 text-[13.5px] leading-relaxed text-ink-muted" data-id="element-198" data-mp="2wu9jqwj3aqmt">{pillar.text}</p>
              </div>
            </Reveal>)}
        </ul>

        <Reveal delay={0.15} data-id="element-199" data-mp="2n3exvt9r9t1w">
          <ReferralButton location="momentum_section" size="lg" showArrow className="mt-12" data-id="element-200" data-mp="2n2dixdpmcmew">
            Quiero empezar
          </ReferralButton>
        </Reveal>
      </div>
    </section>;
}
function AscendingBackdrop() {
  return <div className="pointer-events-none absolute inset-0 -z-0 overflow-hidden" aria-hidden="true" data-id="element-201" data-mp="3fqreznx5d8nt">
      <svg className="absolute inset-0 h-full w-full opacity-[0.5]" viewBox="0 0 1440 700" preserveAspectRatio="none" focusable="false" data-id="element-202" data-mp="1dvbtmtnxap5e">
        <defs data-id="element-203" data-mp="143xree4l7b8k">
          <linearGradient id="riseFill" x1="0" y1="1" x2="0" y2="0" data-id="element-204" data-mp="144gz720iwj8v">
            <stop offset="0%" stopColor="#F7A23B" stopOpacity="0" data-id="element-205" data-mp="192s8nbmworqk" />
            <stop offset="100%" stopColor="#F7A23B" stopOpacity="0.16" data-id="element-206" data-mp="v4amhicnfnar" />
          </linearGradient>
        </defs>
        <path d="M0 640 L120 600 L240 618 L360 540 L480 566 L600 470 L720 500 L840 400 L960 428 L1080 320 L1200 352 L1320 224 L1440 262 L1440 700 L0 700 Z" fill="url(#riseFill)" data-id="element-207" data-mp="z65qwvpvmgsr" />
        <path d="M0 640 L120 600 L240 618 L360 540 L480 566 L600 470 L720 500 L840 400 L960 428 L1080 320 L1200 352 L1320 224 L1440 262" fill="none" stroke="#F7A23B" strokeOpacity="0.35" strokeWidth="1.5" data-id="element-208" data-mp="q468byz7r4np" />
      </svg>
      <div className="absolute inset-0 bg-base/55" data-id="element-209" data-mp="8vdn3k1ewcda" />
    </div>;
}